<template>
  <div class="auth-container d--f jc--c ai--c">
    <AppCard class="pa-30px" style="width: 540px; max-width: 90vw">
      <template #header>
        <SectionHeader :title="title" :description="description" centered />
      </template>

      <ElForm ref="formRef" :model="formData" :rules="rules" @submit.prevent="handleSubmit">
        <slot :formData="formData" />

        <AppButton variant="primary" type="submit" class="full-width mt-20px">{{ title }}</AppButton>

        <slot name="footer" />
      </ElForm>
    </AppCard>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElForm } from "element-plus";
import { AppButton, AppCard } from "@/components/ui";

import SectionHeader from "@/components/SectionHeader.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  submitDescription: {
    type: String,
    default: "",
  },
  rules: {
    type: Object,
    required: true,
  },
});

const formData = defineModel({ type: Object, default: {} });

const emit = defineEmits(["submit"]);

const formRef = ref(null);

const handleSubmit = () => {
  formRef.value?.validate(async (valid) => {
    if (valid) {
      emit("submit", formData.value);
    }
  });
};
</script>

<style lang="scss" scoped>
.auth-container {
  position: relative;
  min-height: 100vh;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("@/assets/images/auth-background.jpg") no-repeat center;
    background-size: cover;
    filter: blur(10px);
    z-index: -1;
  }
}
</style>
